<div class="product-task-list-container">
  <div ngbAccordion>
    @for (groups of tasks; track $index; let i = $index) {
      @for (group of groups; track group.title) {
        <div
          ngbAccordionItem="task-panel-{{ i }}"
          class="task-panel"
          id="task-panel-{{ i }}"
          #item="ngbAccordionItem"
          >
          <div ngbAccordionHeader class="custom-header">
            <div class="bolt-container-fluid">
              <div class="bolt-row bolt-align-items-center">
                <div class="bolt-col-sm-12 bolt-col-md-6">
                  <button
                    ngbAccordionButton
                    class="btn btn-link task-btn-link container-fluid text-left pl-0"
                    >
                    <div class="flex-center">
                      @switch (group.icon) {
                        @case ('exclamation-triangle-filled') {
                          <bolt-icon
                            size="sm"
                            [name]="group.icon"
                            color="theme-warning"
                            class="inline-icon"
                          ></bolt-icon>
                        }
                        @case ('exclamation-circle-filled') {
                          <bolt-icon
                            size="sm"
                            [name]="group.icon"
                            color="theme-info"
                            class="inline-icon"
                          ></bolt-icon>
                        }
                        @case ('info-circle-filled') {
                          <bolt-icon
                            size="sm"
                            [name]="group.icon"
                            color="mediumBlue"
                            class="inline-icon"
                          ></bolt-icon>
                        }
                      }
                      <h4 class="task-category">
                        {{ group.title }}
                      </h4>
                      <div class="bolt-space-right-sm">
                        <h4
                          class="task-amount"
                          [ngPlural]="group.taskList.length"
                          >
                          <ng-template ngPluralCase="=1">
                            ({{ group.taskList.length }}&nbsp;task)
                          </ng-template>
                          <ng-template ngPluralCase="other">
                            ({{ group.taskList.length }}&nbsp;tasks)
                          </ng-template>
                        </h4>
                      </div>
                      <bolt-icon
                        size="sm"
                        color="charcoal"
                        name="chevron-down"
                      [attr.name]="
                        item.collapsed ? 'chevron-down' : 'chevron-up'
                      "
                        class="task-collapse-icon"
                      ></bolt-icon>
                    </div>
                  </button>
                </div>
                <div class="bolt-col-sm-12 bolt-col-md-6">
                  <div class="flex-center bolt-space-left-md right-side-row">
                    <div class="outer-for-vert-line">
                      @switch (group.buttonType) {
                        @case ('info-button') {
                          <bolt-button
                            size="sm"
                            (click)="getDispatchGroupTaskAction(group)"
                            [name]="group.icon"
                            [attr.id]="'tlc-task-info-btn'"
                            type="solid"
                            class="task-button"
                            >{{ getGroupTaskActionLabel(group) | titlecase }}
                          </bolt-button>
                        }
                        @case ('warning-button') {
                          <bolt-button
                            size="sm"
                            (click)="getDispatchGroupTaskAction(group)"
                            [name]="group.icon"
                            [attr.id]="'tlc-task-warning-btn-' + group.page"
                            type="solid"
                            class="task-button"
                            >{{ getGroupTaskActionLabel(group) | titlecase }}
                          </bolt-button>
                        }
                        @case ('error-button') {
                          <bolt-button
                            size="sm"
                            (click)="getDispatchGroupTaskAction(group)"
                            [name]="group.icon"
                            [attr.id]="'tlc-group-error-btn'"
                            type="solid"
                            class="task-button"
                            >{{ getGroupTaskActionLabel(group) | titlecase }}
                          </bolt-button>
                        }
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="bolt-container-fluid">
                  @for (task of group.taskList; track task.message; let t = $index) {
                    <div
                      class="bolt-row bolt-align-items-center bolt-justify-content-between bolt-space-bottom-md"
                      >
                      <div class="bolt-col-sm-12 bolt-col-md">
                        <div class="task-message">
                          <ul>
                            <li>
                              <span [innerHTML]="getTaskMessage(task)"></span>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="bolt-col-sm-12 bolt-col-md-auto">
                        @if (task.resolve) {
                          <div class="align-top">
                            <div
                              class="right-side-row flex-center bolt-space-left-md"
                              >
                              <div class="outer-for-vert-line">
                                @switch (group.buttonType) {
                                  @case ('info-button') {
                                    <bolt-button
                                      size="sm"
                                      [attr.id]="'tlc-task-sec-info-btn'"
                                      class="task-button"
                                      (click)="getDispatchTaskAction(group, task)"
                                      >{{ getTaskActionLabel(group, task) }}
                                    </bolt-button>
                                  }
                                  @case ('warning-button') {
                                    <bolt-button
                                      size="sm"
                                      [attr.id]="'tlc-task-sec-warning-info-btn'"
                                      class="task-button"
                                      (click)="getDispatchTaskAction(group, task)"
                                      >{{ getTaskActionLabel(group, task) }}
                                    </bolt-button>
                                  }
                                  @case ('error-button') {
                                    <bolt-button
                                      size="sm"
                                      [attr.id]="'tlc-task-sec-error-info-btn'"
                                      class="task-button"
                                      (click)="getDispatchTaskAction(group, task)"
                                      >{{ getTaskActionLabel(group, task) }}
                                    </bolt-button>
                                  }
                                }
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      }
    }
  </div>
</div>
